import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import "../../../../cssfiles/homepage.css";
import { useDispatch, useSelector } from "react-redux";
import {
  gatewaylivedata,
  getgatewaylist,
} from "../../../../Restclient/datacollection";
import { updategatewaylist } from "../../../../store/diagnostic_data";

export default function TableGateway(props) {
  const dispatch = useDispatch();

  const tagcollectionvalue = useSelector(
    (state) => state.mainpagedata.tagcollectionvalues
  );

  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates
  );

  let projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const selectedtreepath = useSelector(
    (state) => state.mainpagedata.treepathselected
  );

  const userdetails = useSelector((state) => state.logindata.userdetails);

  const [tableHead, setTableHead] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [gatewayList, setGatewayList] = useState([]);
  const [gatewayId, setGatewayId] = useState([]);
  const [conn, setConn] = useState([]);

  if (selectedtreepath[selectedtreepath.length - 1] === "Delhi Works") {
    projectId = "3d808646-bff8-4406-ae3d-d63a19f26ddd";
  } else if (selectedtreepath[selectedtreepath.length - 1] === "Baroda Works") {
    projectId = "2041b177-a1e7-449b-8c33-5ed911543122";
  }

  function getgatewaylistcallback(res) {
    setGatewayList(res);
  }

  function gatewaylivedatacallback(res) {
    const val = res.data.map((value) => {
      return value[1];
    });
    setConn(val);
  }

  useEffect(() => {
    getgatewaylist(
      
      getgatewaylistcallback
    );
  }, []);

  useEffect(() => {
    gatewaylivedata(gatewayId, gatewaylivedatacallback);
  }, [gatewayId]);

  useEffect(() => {
    let rows_values = [];
    let rows_values1 = [];
    let name = [];
    let id = [];
    let sn = [];

    gatewayList.map((gateway) => {
      name.push(gateway.Name);
      id.push(gateway.GatewayID);
      sn.push(gateway.SN);
    });

    rows_values = id.map((value, index) => [
      name[index],
      sn[index],
      conn[index],
    ]);

    rows_values1 = id.map((value, index) => [
      id[index],
      sn[index],
      conn[index],
    ]);

    setTableRows(rows_values);
    dispatch(updategatewaylist(rows_values1));
  }, [conn]);

  useEffect(() => {
    let head_values = props.widgetprop.props.extended.column_categories;
    let rows_values = [];
    let rows_values1 = [];
    let name = [];
    let id = [];
    let sn = [];

    gatewayList.map((gateway) => {
      name.push(gateway.Name);
      id.push(gateway.GatewayID);
      sn.push(gateway.SN);
    });
    setGatewayId(id);

    rows_values = id.map((value, index) => [
      name[index],
      sn[index],
      conn[index],
    ]);

    rows_values1 = id.map((value, index) => [
      id[index],
      sn[index],
      conn[index],
    ]);

    setTableHead(head_values);
    setTableRows(rows_values);
    dispatch(updategatewaylist(rows_values1));
  }, [props.widgetprop, tagcollectionvalue, sdate_edate_selected, gatewayList]);

  return (
    <>
      {tableRows.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            height: "100%",
            paddingLeft: "0px",
            backgroundColor: "var(--secondary-backgroundLK)",
            paddingRight: "0px",
          }}
          elevation={0}
        >
          <Table stickyHeader sx={{ width: "100%" }} size="small">
            {
              <TableHead>
                <TableRow sx={{ border: "0px" }}>
                  {tableHead.map((table_head_value, index) => (
                    <TableCell
                      key={index + 1}
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablehead.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablehead.fontweight,
                        color: "var(--grey-variation-tableLK)",
                        backgroundColor: "var(--secondary-backgroundLK)",
                      }}
                    >
                      {table_head_value}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            }
            <TableBody>
              {tableRows.map((row, index) => (
                <TableRow
                  key={index + 1}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    height: "9px",
                    "& > *": {
                      borderBottom: "1px solid var(--table-boarder-line)",
                    },
                  }}
                >
                  {row.map((row_value, index) => (
                    <TableCell
                      key={index + 1}
                      component="th"
                      scope="row"
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                        color:
                          row_value === "Connected" || row_value === "ON TARGET"
                            ? "#00943D"
                            : row_value === "Disconnected" ||
                              row_value === "unknown" ||
                              row_value === "DEVIATED BY 3%"
                            ? "#DC272D"
                            : "var(--grey-variation-tablerowsLK)",
                      }}
                    >
                      {row_value}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
